export { default } from './es/icons/PngTwoTone';